import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgEmblemWebsite = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Website</title>
    <circle cx={12} cy={12} r={10} fill="#2F3639" />
    <path
      d="M10.818 12.591a2.956 2.956 0 0 0 4.457.32l1.774-1.774a2.956 2.956 0 0 0-4.18-4.18l-1.017 1.01"
      stroke="#fff"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.183 11.41a2.955 2.955 0 0 0-4.458-.32L6.95 12.863a2.956 2.956 0 0 0 4.18 4.18l1.011-1.01"
      stroke="#fff"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgEmblemWebsite;
